import { TApplicationState } from '../../types/redux';
import { INewbuildingProblem } from '../../types/newbuilding/problem';

export function getProblems(state: TApplicationState): INewbuildingProblem[] {
  const {
    newbuilding: { problems },
  } = state;

  if (!problems) {
    return [];
  }

  return problems;
}
